<template>
    <div class="lock-unlock-statistics-box">
        <div>
            <el-form inline>
                <el-form-item label="币种：" style="padding-top: 20px">
                    <el-autocomplete class="inline-input"
                                     v-model="queryParams.coinType"
                                     :fetch-suggestions="querySearch"
                                     placeholder="请输入币种">
                        <i class="el-icon-close el-input__icon" slot="suffix"
                           @click="cleanSearchCoin" style="cursor:pointer;">
                        </i>
                    </el-autocomplete>
                </el-form-item>
                <el-form-item style="padding-top: 20px">
                    <el-button type="primary" @click="queryData">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div class="statistics-list">
            <el-table class="statistics-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="lockAndUnlockList" :row-key="() => Math.random()">
                <el-table-column prop="coinType" label="锁仓挖矿币种" width="150px"></el-table-column>
                <el-table-column label="昨日累计提交解锁资产" show-overflow-tooltip
                                 :render-header="(h,obj) => renderTipsHeader(h,obj,'今日已处理昨日提交的解锁订单并成功进入解锁期的资产总量 / 昨日已提交解锁资产总量',1)">
                    <template slot-scope="scope">
                        <span>{{scope.row.unlockTotalYesterdayUnlocked | numberFormat}} / {{scope.row.unlockTotalYesterdayCreate | numberFormat}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="coinType" label="累计新增提交锁仓资产" show-overflow-tooltip
                                 :render-header="(h,obj) => renderTipsHeader(h,obj,'已确认锁仓资产 / 对应时段提交锁仓资产总量',2)">
                    <template slot-scope="scope">
                        <span>{{scope.row.lockTotalYesterdayLocked | numberFormat}} / {{scope.row.lockTotalYesterdayCreate | numberFormat}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="今日锁仓资产" show-overflow-tooltip
                                 :render-header="(h,obj) => renderTipsHeader(h,obj,'当天新增账资产 / 当天2点时“快照”矿池已锁仓资产',3)">
                    <template slot-scope="scope">
                        <span>{{scope.row.lockTotalTodayCreate | numberFormat}} / {{scope.row.lockingTotalToday | numberFormat}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="今日到期解锁资产" show-overflow-tooltip
                                 :render-header="(h,obj) => renderTipsHeader(h,obj,'当天已解锁到账资产 / 当天应解锁到账资产',4)">
                    <template slot-scope="scope">
                        <span>{{scope.row.shouldUnlockTotalTodayForDone | numberFormat}} / {{scope.row.shouldUnlockTotalToday | numberFormat}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="累计解锁中资产">
                    <template slot-scope="scope">
                        <span>{{scope.row.unlockingTotal | numberFormat}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="昨日锁仓">
                    <template slot-scope="scope">
                        <span>{{scope.row.lockingYesterday | numberFormat}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button type="danger" @click="allUnlock(scope.row)">整仓解锁</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

    </div>
</template>

<script>
    import '../store';
    import api from '../api';
    import moment from 'moment';
    import LANGUAGES from "../common/languages_code";
    import {STAKINGUNLOCKSTATUS, STAKINGLOCKSTATUS} from "../common/constants";

    export default {
        name: 'LockAndUnlockStatistics',
        components: {},
        data() {
            return {
                lockAndUnlockList: [],
                queryParams: {
                    coinType: "",
                },
                coinTypes: [],
                loading: false
            }
        },
        filters: {
            numberFormat(value) {
                return value == null || value == "" ? 0 : value;
            }
        },
        methods: {
            queryData() {
                this.getLockAndUnlock(this.queryParams);
            },
            getAllSupportCoin() {
                api.getAllSupportCoin().then(({data}) => {
                    this.coinTypes = data;
                });
            },
            getLockAndUnlock(query) {
                api.lockAndUnlock(query).then(({data}) => {
                    this.lockAndUnlockList = data;
                });
            },
            allUnlock(row) {
                this.$confirm('是否确认整仓解锁？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.allUnlock({coinType: row.coinType}).then((data) => {
                        if (data.code == 0) {
                            this.getLockAndUnlock(this.queryParams);
                            this.$message.success('解锁成功!');
                        } else {
                            this.$message.success(data.msg);
                        }
                    });
                }).catch(() => {
                });
            },
            querySearch(queryString, cb) {
                var results = [];
                var coinList = this.coinTypes;
                results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
                results = results.map((v, i, arr) => {
                    return {
                        value: v
                    }
                });
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                let tempData = this.coinTypes;
                return (tempData) => {
                    return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            cleanSearchCoin() {
                this.queryParams.coinType = '';
            },
            renderTipsHeader(h, {column}, index, type) {
                return h(
                    'div', [
                        h('span', column.label),
                        h('el-tooltip', {
                            props: {
                                effect: 'dark',
                                content: index,
                                placement: 'top'
                            },
                        }, [
                            h('i', {
                                class: 'el-icon-question',
                                style: 'color:#409EFF;margin-left:5px;'
                            })
                        ]),
                        h('br'),
                        h('span', this.formatTime(type)),
                    ]
                );
            },
            formatTime(type) {
                if(!this.lockAndUnlockList || !this.lockAndUnlockList[0]){
                    return;
                }
                let format = 'YYYY-MM-DD HH:mm';
                if (type == 1) {
                    return moment(this.lockAndUnlockList[0].unlockYesterdayBeginTime).format(format) + "至" + moment(this.lockAndUnlockList[0].unlockYesterdayEndTime).format(format)
                } else if (type == 2) {
                    return moment(this.lockAndUnlockList[0].lockYesterdayBeginTime).format(format) + "至" + moment(this.lockAndUnlockList[0].lockYesterdayEndTime).format(format)
                } else if (type == 3) {
                    return moment(this.lockAndUnlockList[0].lockTodayBeginTime).format(format) + "至" + moment(this.lockAndUnlockList[0].lockTodayEndTime).format(format)
                } else if (type == 4) {
                    return moment(this.lockAndUnlockList[0].unlockTodayBeginTime).format(format) + "至" + moment(this.lockAndUnlockList[0].unlockTodayEndTime).format(format)
                }
                return '';
            }
        },
        created() {
            this.getAllSupportCoin();
            this.getLockAndUnlock(this.queryParams);
        }
    };
</script>

<style lang="less" scoped>
    .lock-unlock-statistics-box {
        .statistics-list {
            border: 1px solid #f2ece2;
            clear: both;
            width: 100%;
            .statistics-table {
                margin-top: 30px;
            }
        }
    }
</style>

